// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import App from "./App";
import ConsultantLogin from "./ConsultantLogin";
import ConsultantDashboard from "./ConsultantDashboard";
import reportWebVitals from "./reportWebVitals";
import ActiveUserChat from "./ActiveUserChat";
import ActiveConsultantChat from "./ActiveConsultantChat";
import PaymentFailed from "./PaymentFailed";
import PaymentSuccess from "./PaymentSuccess";
import LandingPage from "./LandingPage";
import PaystackCallback from "./PaystackCallback";

const Root = () => (
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      {/* <Route path="/consultant-login" element={<ConsultantLogin />} /> */}
      <Route path="/dashboard" element={<ConsultantDashboard />} />
      <Route path="/activeuserchat" element={<ActiveUserChat />} />
      <Route path="/activeconsultantchat" element={<ActiveConsultantChat />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/paystack-callback" element={<PaystackCallback />} />
      <Route path="/landingpage" element={<LandingPage />} />

    </Routes>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
